import { Component, OnDestroy, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';
import { DeleteCategoryDialogComponent } from '../delete-category-dialog/delete-category-dialog.component';

import { DataService, HTTPService, HelperService, CalculationService, FormatService } from 'app/services';
import { config, inspectionItemColorIndex, messages } from 'app/constants';
import { currency } from 'app/constants/currency.constants';

import { find, debounce } from 'lodash';
import { Subscription } from 'rxjs';
import { itemTypeLabel } from 'app/constants/itemType.constants';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';

@Component({
  selector: 'app-canned-service-dialog',
  templateUrl: './canned-service-dialog.component.html',
  styleUrls: ['./canned-service-dialog.component.scss'],
  providers: [DialogService],
})
export class CannedServiceDialogComponent implements OnInit, OnDestroy {
  @Input() categoryType: string = '';
  categoryName: any = '';
  categorId: any = '';
  checkUniqueCategory = debounce(this._checkUniqueCategory, 600);

  serviceInputVisible: boolean = true;
  config: any = config;
  usd: string = currency.USD;
  categories: any = [];
  categoryResults: any = [];
  validate: any = {};
  cannedInspectionSuggestion: any[] = [];

  activeRow: number = 0;
  closeItem: number = 0;
  closeAllItem: number;

  service: any = {
    _id: null,
    title: null,
    titleFR: null,
    status: true,
    category: null,
    price: 0,
    items: [],
    itemCount: null,
    notes: null,
    serviceTotal: {
      part: 0,
      labor: 0,
      tire: 0,
      other: 0,
      sublet: 0,
      total: 0,
    },
  };
  serviceErrors: any = {};
  focus = { title: true };
  errors: any = { title: '' };
  isEditMode: boolean = false;
  isLoading: boolean = false;
  isProcessing: boolean = false;
  serviceInspLoading: boolean = false;
  isInspectionSearchVisible: boolean = false;
  isSearchingInspection: boolean = false;
  defaultCount = {
    categories: 0,
    items: 0,
    condition: {
      good: 0,
      normal: 0,
      bad: 0,
      notInspected: 0,
    },
    images: 0,
    audios: 0,
  };
  counts = this.helperService.deepCopy(this.defaultCount);
  categoryItemText: string = '';
  dragDisabled = true;
  isOtherTaxable: boolean = true;
  isSubletTaxable: boolean = false;
  isEstimateInspection: boolean = false;
  addedServiceByEstimate: boolean = false;
  dataListener: Subscription;
  companyLocalizationSubscription: Subscription;
  itemTypeLabel = { ...itemTypeLabel };
  isShowError: boolean = false;
  isSubletTrackingEnabled: boolean = false;
  isQTQAddOnEnable: boolean = false;
  qtqDefaultDisabled: boolean = false;
  itemId: string = '';
  activityLogs: any[] = [];
  selectedTab = 0;
  partsLookupDropDownList: any[] = [];
  isQuickServiceEnabled: boolean = false;
  isTireStorage2Enabled: boolean = false;
  companyLocalization: boolean = false;
  currentLang: string = 'en';
  @ViewChild('submitBtn') submitBtn!: ElementRef; 

  constructor(
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private httpService: HTTPService,
    private formatService: FormatService,
    private calculationService: CalculationService,
    private helperService: HelperService,
    public dataService: DataService,
  ) { }

  ngOnInit() {
    this.getLocalizationFlags();
    this.isSubletTrackingEnabled = this.dataService.isSubletTrackingEnabled;
    this.isQTQAddOnEnable = this.dataService.isQTQAddOnEnable;
    this.isQuickServiceEnabled = this.dataService.isQuickServiceEnabled;
    this.isTireStorage2Enabled = this.dataService.isTireStorage2Enabled;
    this.getCategoryList();
    this.service.selectAllItems = true;

    if (this.dConfig.data && this.dConfig.data._id) {
      this.itemId = this.dConfig.data._id;
      this.getServiceById(this.dConfig.data._id);
      this.getLogs();
      this.isEditMode = true;
    } else if (this.dConfig.data && this.dConfig.data.title) {
      this.currentLang = this.dConfig.data.currentLang || 'en'
      this.setServiceDataForCreateFromEstimate(this.dConfig.data);
    } else {
      this.addItem();
    }

    if (this.isQuickServiceEnabled) {
      this.partslookupItemList();
    }

    this.onSearchInspection('');
    this.setDataListener();
  }
  ngAfterViewInit(){
    this.updateSubmitButtonId()
  }


  getLocalizationFlags() {
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    this.companyLocalizationSubscription = this.dataService.getCompanyLocalization().subscribe((value) => {
      if (value) {
        this.companyLocalization = value
        if (!isMultiLocationEnabled) {
          this.httpService.getCompanyPreferredLanguage().then((res: any) => {
            const lang = res.preferredLanguage
            if (lang) {
              this.currentLang = lang.toLowerCase();
            }
          });
        } else {
          this.httpService.getCompanyDetails(this.helperService.getCompany().companyId).then((company: any) => {
            const lang = company.shop.preferredLanguage;
            if (lang) this.currentLang = lang.toLowerCase();
          })
        }
      }
    })
  }

  ngOnDestroy(): void {
    if (this.dataListener) {
      this.dataListener.unsubscribe();
    }
    if (this.companyLocalizationSubscription) {
      this.companyLocalizationSubscription.unsubscribe();
    }
  }
  updateSubmitButtonId() {

    const id = this.isEditMode ? 'submit-btn-canned-service-edit' : 'submit-btn-canned-service-create';

    const isValid = this.validateData(false);
    console.log(isValid)
    if (!isValid) {
      this.submitBtn.nativeElement.id = 'submit-btn'
      return;
    };

    this.submitBtn.nativeElement.id = id
  }

  setDataListener() {
    this.dataListener = this.dataService.getData().subscribe((payload) => {
      if (payload) {
        const { type, key, data } = payload.data;

        if (type === 'passdata' && key === 'canned-service-item') {
          let items = [];

          // Usually for tires because tires can have more then 1 items during creation
          if (data.items && data.items.length) {
            items = data.items;
          } else {
            items = [data];
          }

          items.forEach((item) => {
            this.addItem(item);
          });
        }
      }
    });
  }
  getLogs() {
    const query = <any>{};
    query.entityId = this.itemId;
    this.httpService.getActivityLog(query).then(
      (data: any) => {
        console.log(data);
        if (data) {
          this.activityLogs = this.formatService.formateCatlogActivityLogs(data);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }
  getOtherTax() {
    this.httpService.getOwnShop().then(
      (shop: any) => {
        if (shop) {
          this.isOtherTaxable = shop.other;
          this.isSubletTaxable = shop?.sublet || false;
        }
      },
      (err) => { },
    );
  }

  drop(event: CdkDragDrop<string[]>) {
    this.dragDisabled = true;
    if (event.currentIndex !== this.service.items.length - 1) {
      moveItemInArray(this.service.items, event.previousIndex, event.currentIndex);
    }
  }

  addItem(item: any = null) {
    const data = {
      title: '',
      isTaxable: true,
      adjQtyWithTire: false,
      type: '',
      count: '',
      price: '',
      subTotal: 0,
      itemData: item,
      // checked: true
    };

    if (item) {
      this.service.items.splice(-1, 0, data);
    } else {
      this.service.items.push(data);
    }
  }

  selectAll() {
    this.service.selectAllItems = !this.service.selectAllItems;
    this.service.items.forEach((element, i) => {
      if (this.service.selectAllItems && i !== this.service.items.length - 1) element.checked = true;
      else element.checked = false;
    });
    this.calculateTotal();
  }

  close() {
    this.ref.close();
  }

  getUnassignedCategory() {
    const unassignedCategory = find(this.categories, { name: 'Unassigned' });
    if (unassignedCategory && unassignedCategory._id) {
      return {
        categoryId: unassignedCategory._id,
        name: unassignedCategory.name,
      };
    }
    return null;
  }

  handleChange(name: string, value: string) {
    const qtqAddOn = this.service.qtqAddOn;
    this.service[name] = value;

    if (name === 'qtqAddOn') {
      this.service.qtqDefault = this.service.qtqAddOn;

      if (!qtqAddOn && this.service.qtqAddOn) {
        this.service.items.forEach((item: any) => {
          item.checked = !!item.title;
          item.adjQtyWithTire = !!item.title;
        });
      }

      this.dataService.updateqtqAddonEvent(value);
    }
  }

  handleFocus(name: string) {
    if (name) {
      this.focus[name] = true;
    }

    this.errors[name] = '';
  }

  handleBlur(name: string) {
    if (name) {
      this.focus[name] = false;
    }

    this.validate[name] = '';
  }

  onCategorySelect(category: any) {
    if (category._id && category.name) {
      this.service.category = {
        categoryId: category._id,
        name: category.name,
      };
    }
  }

  createCategory(data: any) {
    this.httpService.createTag(data).then(
      (category) => {
        if (category) {
          this.helperService.showToaster('success', messages.categoryCreated);
          this.categories.push(category);
          this.onCategorySelect(category);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err.message);
      },
    );
  }

  getCategoryList() {
    this.httpService.getTags(config.category.service).then(
      (categories: any[]) => {
        if (categories) {
          this.categories = [...categories];
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  getServiceById(id: string) {
    this.isLoading = true;
    this.httpService.getCannedServiceById(id).then(
      (service: any) => {
        if (service) {
          this.setServiceDataForUpdate(service);
        }

        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        this.helperService.showToaster('error', err);
      },
    );
  }

  setServiceDataForCreateFromEstimate(service) {
    this.addedServiceByEstimate = true;
    if (this.companyLocalization) {
      if (this.currentLang === 'en') {
        this.service.title = service.title;
      } else {
        this.service.titleFR = service.title;
      }
    }
    else {
      this.service.title = service.title;
    }
    this.service.price = service.price;
    this.service.notes = service.notes;

    if(service.inspection && !service.inspection.isTireStorageInspection) service.inspection.isTireStorageInspection = service.inspection?.inspectionId?.isTireStorageInspection
    this.service.inspection = service.inspection;
    
    if (this.service.inspection && this.service.inspection.inspectionId) {
      this.isEstimateInspection = true;
      this.setInspectionCounts(this.service.inspection.inspectionId);
    }

    if (this.isQTQAddOnEnable) {
      this.service.qtqAddOn = false;
      this.service.qtqDefault = false;
    }

    if (service.items.length > 0) {
      const itemTypes: any = ['partLookup', 'part', 'labor', 'tire', 'tireStorage', 'bundle', 'hazmatFee', 'other', 'partLookUp', 'sublet'];

      if (service.items?.length) {
        this.service.items = service.items.filter(({ type }) => itemTypes.includes(type));
        this.service.items.forEach((item: any) => {
          if (item.itemId === item._id) {
            delete item.itemId;
          }

          item.tags = [];
          item.status = !!item.type;
          item.netSubtotal = item.subTotal;
          item.checked = true;

          if (item.type === 'bundle') {
            item.flatRate = item.subTotal;
            if (item.subItems?.length) {
              item.subItems.forEach((subItem: any) => {
                subItem.tags = [];
              });
            }
          }

          delete item._id;
        });
      }
    } else {
      this.addItem();
    }

    this.calculateTotal();
  }

  setServiceDataForUpdate(service: any) {
    if (service._id && !this.dConfig.data.isCreateDuplicate) {
      this.service._id = service._id;
    }
console.log("setting service", service)
    if (service.category && service.category.categoryId && service.category.name) {
      this.service.category = {
        name: '',
        categoryId: '',
      };
      this.service.category.categoryId = service.category.categoryId;
      this.service.category.name = service.category.name;
    }

    this.service.qtqAddOn = service.qtqAddOn;
    this.service.qtqDefault = service.qtqDefault;
    if (service.qtqDefault) this.qtqDefaultDisabled = true;

    if (this.dConfig.data.isCreateDuplicate) {
      this.service.title = `Copy of ${service.title}`;
    } else {
      this.service.title = service.title;
    }
    if (this.companyLocalization) {
      if (this.dConfig.data.isCreateDuplicate) {
        this.service.titleFR = `Copy of ${service.titleFR}`;
      } else {
        this.service.titleFR = service.titleFR;
      }
    }

    this.service.price = service.price;
    this.service.itemCount = service.itemCount;
    this.service.status = service.status;
    this.service.items = service.items;
    this.service.inspection = service.inspection;
    this.service.notes = service.notes;

    if (this.service.inspection && this.service.inspection.inspectionId) {
      this.isEstimateInspection = false;
      this.setInspectionCounts(this.service.inspection.inspectionId);
    }

    if (this.service.items && this.service.items.length) {
      this.service.items.forEach((item: any) => {
          item.netSubtotal = item.subTotal;
      });
    }

    this.calculateTotal();
    this.addItem();
    this.calculateTotal();
  }

  /** Delete services */
  itemDelete(item: any) {
    const serviceItem = this.service.items[item];
    if(serviceItem.type === 'tireStorage' && serviceItem.itemId && this.service.inspection?.inspectionId) this.service.inspection = {}
    this.service.items.splice(item, 1);
    if (this.service.items.length === 0) {
      this.service.items.push({
        title: null,
        type: null,
        count: 0,
        price: null,
        subTotal: 0,
        tags: [],
      });
    }
  }

  /** Search tags */
  searchSuggestion(query, type?: string, variableValue?: any) {
    query = type !== 'prices' ? query.toLowerCase() : query;
    this.categoryResults = [];
    if (type === 'tags') {
      this.categoryResults = this.categories.filter(({ name }) => {
        name = name.toLowerCase();
        if (name && name.includes(query)) {
          return name;
        }
      });
    }
  }

  /** Making object for creating category */
  saveCategory({ name }) {
    this.createCategory({
      name,
      type: config.category.service,
      color: '',
    });
  }

  /** Calculate total cost of canned service */
  calculateTotal() {
    this.service.serviceTotal = this.calculationService.cannedService(this.service, this.isQTQAddOnEnable);
  }

  calculateTotalQtqAddon(serviceItem) {
    if (serviceItem.checked) {
      this.service.serviceTotal.total = this.service.serviceTotal.total + serviceItem.subTotal;
    } else {
      this.service.serviceTotal.total = this.service.serviceTotal.total - serviceItem.subTotal;
    }
  }

  /** Validate Canned service data */
  validateData(showError: boolean = true) {
    let isValid = true;

    if (this.currentLang?.toLowerCase() === 'fr') {
      if (!this.service.titleFR?.trim()) {
        if(showError){
        this.errors.titleFR = 'Service French name is required';
        this.helperService.showToaster('error', 'Service French name is required');
        }
        isValid = false;
      }
    } else {
      if (!this.service.title?.trim()) {
        if(showError){
        this.errors.title = 'Service name is required';
        this.helperService.showToaster('error', 'Service name is required');
        }
        isValid = false;
      }
    }

    if (this.service.items && this.service.items.length) {
      this.service.items.forEach((item: any, index: number) => {
        this.serviceErrors[`${index}`] = {};
        if (item.type || item.title || item.titleFR || item.price || item.count) {
          if (!item.type) {
            if(showError){
              this.serviceErrors[index].type = 'Type is required';
            }
            isValid = false;
          }
          if (this.currentLang.toLowerCase() === 'fr' && item.type != 'partLookUp') {
            if (!item.titleFR && !item.title) {
              if (['part', 'labor', 'tire', 'tireStorage', 'hazmatFee'].includes(item.type)) {
                if(showError){
                  this.serviceErrors[index].titleFR = 'French Name is required';
                }
              } else {
                if(showError){
                  this.serviceErrors[index].titleFR = 'French Description is required';
                }
              }
              isValid = false;
            }
          } else {
            if (!item.title) {
              if (['part', 'labor', 'tire', 'tireStorage', 'hazmatFee'].includes(item.type)) {
                if(showError){
                  this.serviceErrors[index].title = 'Name is required';
                }
              } else {
                if(showError){
                  this.serviceErrors[index].title = 'Description is required';
                }
              }
              isValid = false;
            }
          }

        } else {
          const itemsLenght = this.service.items.length;
          if (index !== itemsLenght - 1 && itemsLenght > 1) {
            if(showError){
              this.service.items.splice(index, 1);
            }
          }
        }
      });
    }

    return isValid;
  }

  /** Make canned service object */
  makeServiceObject() {
    const service = this.helperService.deepCopy(this.service);
    service.title = this.helperService.trimString(service.title);
    service.titleFR = this.helperService.trimString(service.titleFR);
    if (service.items && service.items.length) {
      service.items.forEach((item: any, index: number) => {
        this.serviceErrors[`${index}`] = {};
        if (!item.type && !item.title && !item.titleFR && !item.price && !item.count) {
          service.items.splice(index, 1);
        }
      });
    }

    if (!service.category) {
      service.category = this.getUnassignedCategory();
    }

    service.itemCount = service.items.length;

    if (service.inspection && service.inspection.inspectionId) {
      if (this.addedServiceByEstimate) {
        service.inspection = {
          title: service.inspection.inspectionId.title,
          isAlCertified: service.inspection.inspectionId.isAlCertified,
          inspectionId: service.inspection.inspectionId.inspectionId || service.inspection.inspectionId.associatedInspectionId,
          isTireStorageInspection: service.inspection.isTireStorageInspection
        };
      } else {
        service.inspection = {
          title: service.inspection.inspectionId.title,
          inspectionId: service.inspection.inspectionId._id,
          isAlCertified: service.inspection.inspectionId.isAlCertified,
          isTireStorageInspection: service.inspection.isTireStorageInspection
        };
      }
      if (service.inspection.isAlCertified) service.inspection.certifiedInspectionId = service.inspection.inspectionId;
    }

    return service;
  }

  /** Make API call for creating or updating canned servies */
  onSubmit() {
    if (this.validateData()) {
      if (this.service._id) {
        if (this.isProcessing) {
          return;
        }
        this.calculateTotal();
        this.isProcessing = true;
        this.httpService.updateServiceById(this.makeServiceObject()).then(
          (res) => {
            if (res) {
              this.ref.close();
              this.isProcessing = false;
              this.helperService.showToaster('success', messages.cannedServiceUpdate);
              this.dataService.sendData(this.dataService.typeUpdate('services-list', 'services'));
            }
          },
          (err) => {
            this.isProcessing = false;
            this.helperService.showToaster('error', err);
          },
        );
      } else {
        if (this.isProcessing) {
          return;
        }

        this.isProcessing = true;
        this.httpService.createCannedService(this.makeServiceObject()).then(
          (res) => {
            if (res) {
              this.ref.close();
              this.isProcessing = false;
              this.helperService.showToaster('success', messages.cannedServiceCreation);
              this.dataService.sendData(this.dataService.typeAdd('services-list', 'services'));
            }
          },
          (err) => {
            this.isProcessing = false;
            this.helperService.showToaster('error', err);
          },
        );
      }
    }
  }

  onSelectInspection(inspection: any) {
    this.service.inspection = {
      title: inspection.title,
      inspectionId: inspection,
      isAlCertified: inspection.isAlCertified,
      isTireStorageInspection: inspection.isTireStorageInspection
    };
    this.isEstimateInspection = false;
    this.setInspectionCounts(inspection);
  }

  onSearchInspection(query: string) {
    this.isSearchingInspection = true;
    this.httpService.searchInspection(query).then(
      (inspections: any) => {
        if (inspections && inspections.records) {
          this.cannedInspectionSuggestion = inspections.records;
          this.cannedInspectionSuggestion.forEach((inspection) => {
            inspection.categoryCount = inspection.category.length;
            inspection.itemCount = 0;

            if (inspection.categoryCount) {
              inspection.category.forEach(({ inspectionItems }) => {
                if (inspectionItems) {
                  inspection.itemCount += inspectionItems.length;
                }
              });
            }
          });
        }
        this.isSearchingInspection = false;
      },
      (err) => {
        this.isSearchingInspection = false;
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleOpenInspectionDialog(inspection) { }

  handleConfirmInspectionDelete() {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Delete inspection`,
        message: `Are you sure you want to delete this inspection?`,
        button: {
          success: { title: 'Delete', backgroundColor: '#d47877' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.service.inspection = {};
      }
      onClose.unsubscribe();
    });
  }

  setInspectionCounts(inspection: any) {
    this.counts.categories = 0;
    this.counts.items = 0;
    let isItemExists: boolean = false;
    if (inspection.category && inspection.category.length) {
      if (this.isEstimateInspection) this.counts.categories = inspection.category.length;
      inspection.category.forEach((category: any) => {
        if (category.inspectionItems.length) {
          if (this.isEstimateInspection) this.counts.items += category.inspectionItems.length;

          category.inspectionItems.forEach(({ attachments, colorIndex, isChecked }: any) => {
            if (colorIndex === -1) {
              this.counts.condition.notInspected += 1;
            } else {
              this.counts.condition[inspectionItemColorIndex[colorIndex]] += 1;
            }

            if (isChecked) {
              this.counts.items += 1;
              isItemExists = true;
            }

            if (attachments && attachments.length) {
              attachments.forEach(({ type }) => {
                if (type === 'image') {
                  this.counts.images += 1;
                } else if (type === 'voice') {
                  this.counts.audios += 1;
                }
              });
            }
          });
        }

        if (isItemExists) {
          this.counts.categories += 1;
          isItemExists = false;
        }
      });
    }

    this.categoryItemText = `
    ${this.counts.categories} ${this.counts.categories > 1 ? 'categories' : 'category'}
    ${this.counts.items} ${this.counts.items > 1 ? 'items' : 'item'}
    `;
  }

  showSuggestions(type?: string) {
    if (type === 'tags') {
      this.categoryResults = [...this.categories];
    }
    this.isShowError = false;
  }

  /** Removeing the errors from the fields */
  blurInput(type: string) { }

  onUpdateItem({ name, color, _id }, type: string) {
    const tag = {
      _id,
      color: color,
      type: this.categoryType ? this.categoryType : type,
      name: name.trim(),
    };

    this.httpService.updateTag(tag).then(
      (data) => {
        for (let i = 0; i < this.categories.length; i++) {
          if (this.categories[i]._id === _id) {
            this.categories[i].name = name;
            break;
          }
        }

        for (let i = 0; i < this.categoryResults.length; i++) {
          if (this.categoryResults[i]._id === _id) {
            this.categoryResults[i].name = name;
            break;
          }
        }

        if (this.service.category && this.service.category._id === _id) {
          this.service.category.name = name;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onAutoCompleteSelect(category: any, type?: string) {
    if (type === 'tags') {
      // this.service.category = event;
      if (category._id && category.name) {
        this.service.category = {
          categoryId: category._id,
          name: category.name,
        };
      }
    }
  }

  handleChangeCategory(name: string, value) {
    this.categoryName = value;
    this.checkUniqueCategory();
  }

  _checkUniqueCategory() {
    this.httpService.isCategoryUnique({ name: this.categoryName.trim(), type: 'service_cat' }, this.categorId).then(
      (res) => {
        if (!res) {
          this.isShowError = true;
        } else {
          this.isShowError = false;
        }
      },
      (err) => {
        console.error(err);
      },
    );
  }

  onClearSuggestion(type: string = '') {
    if (type === 'tags') {
      this.categoryResults = [...this.categories];
    }
  }

  searchSuggestionCategory(query: string, type?: string) {
    this.categoryResults = [];
    query = this.helperService.trimString(query);
    if (type === 'tags') {
      this.categoryResults = this.categories.filter(({ name }) => {
        if (name && new RegExp(`${query}`, 'gi').test(name)) {
          return true;
        } else {
          return false;
        }
      });
    }
  }

  deleteCategoryDialog(e) {
    this.httpService
      .getAllCategories(e._id, { isCannedService: true })
      .then((data: any) => {
        if (data.length) {
          const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
            width: '1200px',
            styleClass: 'add-dialog overflow-initial delete-category-dialog',
            showHeader: false,
            data: {
              selectedCategory: e,
              categoryList: this.categoryResults,
              type: 'service_cat',
              isOnlyDelete: false,
              count: data.length,
            },
          });
          const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
            if (isSuccess) {
              const { categoryId, name } = data.category;
              if (this.service && this.service.category?.name === name) {
                this.service.category.name = selectedName;
              }
              this.categories.map((item, index) => {
                if (item._id === categoryId) this.categories.splice(index, 1);
              });
              this.categoryResults = [...this.categories];
            }
            onClose.unsubscribe();
          });
        } else if (data.length === 0) {
          const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
            width: '1200px',
            styleClass: 'add-dialog overflow-initial delete-category-dialog',
            showHeader: false,
            data: {
              selectedCategory: {...e, categoryId: e._id},
              categoryList: this.categoryResults,
              type: 'service_cat',
              isOnlyDelete: true,
              count: 0,
            },
          });
          const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
            if (isSuccess) {
              const { categoryId, name } = data.category;
              if (this.service && this.service.category?.name === name) {
                this.service.category.name = selectedName;
              }
              this.categories.map((item, index) => {
                if (item._id === categoryId) this.categories.splice(index, 1);
              });
              this.categoryResults = [...this.categories];
            }
            onClose.unsubscribe();
          });
        }
      })
      .catch((err) => this.helperService.showToaster('error', err));
    // const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
    //   width: '1200px',
    //   styleClass: 'add-dialog overflow-initial delete-category-dialog',
    //   showHeader: false,
    //   data: {
    //     selectedCategory : e,
    //     categoryList: this.categoryResults,
    //     type:'service_cat'
    //   },
    // });
    // const onClose = ref.onClose.subscribe(({ isSuccess, data,selectedName }) => {
    //   if (isSuccess) {
    //     const { categoryId, name } = data.category;
    //     if(this.service && this.service.category?.name === name) {this.service.category.name = selectedName};
    //      this.categories.map( (item, index) => {
    //       if(item._id === categoryId) this.categories.splice(index,1);
    //     });
    //     this.categoryResults = [...this.categories];
    //   }
    //   onClose.unsubscribe();
    // });
  }

  partslookupItemList() {
    try {
      this.isLoading = true;
      this.httpService.getPartsLookupItems().then((res: any[]) => {
        if (!res?.length) return;
        this.partsLookupDropDownList = res.map((res) => ({
          ...res,
          status: true,
          type: 'partLookUp',
          title: res.name,
        }));
        this.isLoading = false;

        this.partsLookupDropDownList = this.partsLookupDropDownList.sort((a, b) => a.title.localeCompare(b.title));
      });
    } catch (err) {
      console.log(err);
      this.isLoading = false;

    }
  }
}
